import { datadogRum } from '@datadog/browser-rum'

/**
 * Tracks a custom user action with monitoring providers.
 *
 * @param name - Display name of the action.
 * @param data - Optional data to track with the action.
 */
export const trackAction = (name: string, data?: Record<string, any>) => {
  try {
    datadogRum.addAction(name, data)
  } catch (error) {
    console.error('Error tracking action with Datadog RUM', error)
  }
}
